<template>
  <iframe id="frame" frameborder="0"></iframe>
</template>
<script>
export default {
  name: "Live",
  data() {
    return {
      course_id: this.$route.query.course_id,
      period_id: this.$route.query.period_id,
      bjy_period_id: this.$route.query.bjy_period_id,
      type: this.$route.query.type,
      last_time: 0,
      meeting_id: this.$route.query.meeting_id,
    };
  },
  methods: {
    handle(url) {
      document.getElementById("frame").src = url;
    },
    async onMessgae(event) {
      if (!event.data.totalTime || !this.bjy_period_id) {
        return;
      }
      if (this.last_time == event.data.currentTime) {
        return;
      }
      this.last_time = event.data.currentTime;
      await this.$http.post("/api/app/course/playBack", {
        course_basis_id: parseInt(this.course_id),
        course_periods_id: parseInt(this.bjy_period_id),
        total_time: parseInt(event.data.totalTime),
        last_time: parseInt(event.data.currentTime),
        current_time: 120,
      });
    },
    async play() {
      let course_type = this.$route.query.course_type;
      let liveData;
      if (course_type == 1) {
        liveData = await this.$http.get(
          "/api/app/oto/getLiveRoomCode/" + this.course_id + "/0",
          {},
          {
            onError: () => {
              this.$router.push({ name: "Home" });
            },
          },
        );
      } else if (
        course_type == 2 ||
        course_type == 3 ||
        course_type == 4 ||
        course_type == 15
      ) {
        let data = await this.$http.get(
          "/api/app/getPcRoomCode/course_id=" +
            this.course_id +
            "/chapter_id=" +
            this.period_id,
          {
            type: this.type,
            arrange_id: this.$route.query.arrange_id,
          },
          {
            onError: () => {
              this.$router.push({ name: "Home" });
            },
          },
        );
        liveData = data.chapterInfo;
      } else if (course_type == "meeting") {
        //班会
        let params = {};
        params.type = this.type;
        params.meeting_id = this.meeting_id;
        let data = await this.$http.get(
          "/api/app/getPcRoomCode/course_id=" +
            this.course_id +
            "/chapter_id=" +
            this.period_id,
          params,
        );
        liveData = data;
      } else {
        return;
      }
      let frame = document.getElementById("frame");
      frame.allow =
        "microphone *;camera *;midi *;encrypted-media *;autoplay *;fullscreen *;display-capture *;screen-wake-lock *;";
      document.getElementById("frame").src = liveData.web_url;
    },
  },
  mounted() {
    if (this.bjy_period_id) {
      window.addEventListener("message", this.onMessgae);
    }
    this.$nextTick(async () => {
      this.play();
      $('#meiqia-container').css('display','none')//隐藏联系客服
    });
  },
  beforeDestroy() {
    $('#meiqia-container').css('display','block')//销毁前显示客服
    if (this.bjy_period_id) {
      window.removeEventListener("message", this.onMessgae);
    }
  },
};
</script>
<style lang="scss" scoped>
iframe {
  width: 100%;
  height: 100vh;
  display: block;
}
</style>
